<template>
  <v-toolbar-title>
    <v-btn text icon @click="prev">
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <v-btn text icon @click="next">
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>
    {{current | title}}
  </v-toolbar-title>
</template>
<script>
import moment from 'moment';
import Controls from './Controls.vue';
import { DateFormat } from '@/plugins/date-filter';

export default {
  mixins: [
    Controls,
  ],
  filters: {
    title(date) {
      return moment(date).format(DateFormat.DayDisplay);
    },
  },
};
</script>
